import { render, staticRenderFns } from "./destruction-stockreturnorder.vue?vue&type=template&id=23339c42&"
import script from "./destruction-stockreturnorder.vue?vue&type=script&lang=ts&"
export * from "./destruction-stockreturnorder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports